import React, {Fragment, useEffect, useState} from "react";
import {connect} from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
import IndicatorItem from "./IndicatorItem";
import {getIndicators} from '../../../actions'
import {Dropdown,Form} from "react-bootstrap";
import {FilterItem} from "../DataFilter";
import Container from "react-bootstrap/Container";
import FormCheck from "react-bootstrap/FormCheck";
import {FormGroup, Input, Label} from "reactstrap";



const IndicatorList = ({Indicators: {available_indicators, loading, active_indicators}, getIndicators}) => {
    const [displayStatysyczne,setDisplayStatysyczne] = useState(false)
    const [displayKoszt,setDisplayKoszt] = useState(false)
    const [displayFinansoweOpk,setdisplayFinansoweOpk] = useState(false)
    const [displayFinansowePodmiotu,setdisplayFinansowePodmiotu] = useState(false)
    useEffect(() => {
        getIndicators();


        //eslint-disable-next-line
    }, []);
    return (<Form style={style}>

              <FormGroup as="Dropdown.Toggle" check className='wskaznikiCheckBox'>
                        <Label for="displayStatysyczne" check>

                            Statystyczne</Label>
                   <Input type="checkbox" name="displayStatysyczne" id="displayStatysyczne" onClick={() => setDisplayStatysyczne(!displayStatysyczne)}
                                   checked={displayStatysyczne}/>
                            <span className="caret"  aria-hidden="true"/>
                    </FormGroup>
                    {displayStatysyczne && <Form.Group className={'p-1'}>
                              {!loading && available_indicators.length === 0 ? (
                    <></>) : (available_indicators.filter(indicator=>(active_indicators.includes(indicator.nazwa) && indicator.typ === 'S')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                                                                                               key={indicator.id}/>))}
                     {!loading && available_indicators.length === 0 ||  available_indicators.filter(indicator => indicator.typ ==="S").length === 0? (
                    <p>Brak dostepnych wskaznikow</p>) : (available_indicators.filter(indicator=>(!active_indicators.includes(indicator.nazwa) && indicator.typ === 'S')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                    key={indicator.id}/>))}

                    </Form.Group>}






             <FormGroup as="Dropdown.Toggle" check className='wskaznikiCheckBox'>
                        <Label for="displayKoszt" check>

                            Koszt Zasobow Ludzkich</Label>
                   <Input type="checkbox" name="displayKoszt" id="displayKoszt" onClick={() => setDisplayKoszt(!displayKoszt)}
                                   checked={displayKoszt}/>
                            <span className="caret"  aria-hidden="true"/>
                    </FormGroup>
                    {displayKoszt && <Form.Group className={'p-1'}>
                              {!loading && available_indicators.length === 0 ? (
                    <></>) : (available_indicators.filter(indicator=>(active_indicators.includes(indicator.nazwa) && indicator.typ === 'KZL')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                                                                                               key={indicator.id}/>))}
                     {!loading && available_indicators.length === 0 ||  available_indicators.filter(indicator => indicator.typ ==="KZL").length === 0? (
                    <p>Brak dostepnych wskaznikow</p>) : (available_indicators.filter(indicator=>(!active_indicators.includes(indicator.nazwa) && indicator.typ === 'KZL')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                    key={indicator.id}/>))}

                    </Form.Group>}

             <FormGroup as="Dropdown.Toggle" check className='wskaznikiCheckBox'>
                        <Label for="displayFinansowePodmiotu" check>

                            Finansowe Podmiotu</Label>
                   <Input type="checkbox" name="displayFinansowePodmiotu" id="displayFinansowePodmiotu" onClick={() => setdisplayFinansowePodmiotu(!displayFinansowePodmiotu)}
                                   checked={displayFinansowePodmiotu}/>
                            <span className="caret"  aria-hidden="true"/>
                    </FormGroup>
                    {displayFinansowePodmiotu && <Form.Group className={'p-1'}>
                              {!loading && available_indicators.length === 0 ? (
                    <></>) : (available_indicators.filter(indicator=>(active_indicators.includes(indicator.nazwa) && indicator.typ === 'EFP')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                                                                                               key={indicator.id}/>))}
                     {!loading && available_indicators.length === 0 ||  available_indicators.filter(indicator => indicator.typ ==="EFP").length === 0? (
                    <p>Brak dostepnych wskaznikow</p>) : (available_indicators.filter(indicator=>(!active_indicators.includes(indicator.nazwa) && indicator.typ === 'EFP')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                    key={indicator.id}/>))}

                    </Form.Group>}


            <FormGroup as="Dropdown.Toggle" check className='wskaznikiCheckBox'>
                        <Label for="displayFinansoweOpk" check>

                            Finansowe OPK</Label>
                   <Input type="checkbox" name="displayFinansoweOpk" id="displayFinansoweOpk" onClick={() => setdisplayFinansoweOpk(!displayFinansoweOpk)}
                                   checked={displayFinansoweOpk}/>
                            <span className="caret"  aria-hidden="true"/>
                    </FormGroup>
                    {displayFinansoweOpk && <Form.Group className={'p-1'}>
                              {!loading && available_indicators.length === 0 ? (
                    <></>) : (available_indicators.filter(indicator=>(active_indicators.includes(indicator.nazwa) && indicator.typ === 'EFO')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                                                                                               key={indicator.id}/>))}
                     {(!loading && available_indicators.length === 0) ||  available_indicators.filter(indicator => indicator.typ ==="EFO").length === 0? (
                    <p>Brak dostepnych wskaznikow</p>) : (available_indicators.filter(indicator=>(!active_indicators.includes(indicator.nazwa) && indicator.typ === 'EFO')).map(indicator => <IndicatorItem indicator={indicator}
                                                                                                    key={indicator.id}/>))}

                    </Form.Group>}

        </Form>
    )
};
const style = {
    "overflowY": "auto",
    "height": "inherit"
};
const groupStyle={
    'background': '#51bcda',
    'color': '#ffffff',
    "border-width": "2px",
    "font-weight": '600',
    "font-size": "0.8571em",
    "line-height": "1.35em",
    "text-transform": "uppercase",
    "border": "none",
    "margin": "10px 1px",
   "border-radius": "3px",
    "padding": "11px 22px",
    "cursor": "pointer",
    "text-color":"white",
    "transition": "all 150ms linear",
    "text-align": "center",
    "vertical-align": "middle",
    "display": "inline-block",
    "overflow": "visible",
    // "font-family": "Montserrat", "Helvetica Neue", "Arial"," sans-serif",
}


// export default IndicatorList
const mapStateToProps = state => ({
    Indicators: state.Indicators

});
export default connect(mapStateToProps, {getIndicators})(IndicatorList)